import httpClient from "../lib/HttpClient";

const PaigeReview = {
  // ===================
  // PAAB Analysis (Canada)
  // ===================

  /**
   * Get all PAAB analyses for a document
   * @param {number} documentId
   * @returns {Promise} Array of analysis objects
   */
  getPaabAnalysesForDocument: function (documentId) {
    return httpClient.get("/documents/" + documentId + "/paab_analyses");
  },

  /**
   * Get all PAAB analyses for a library (across all documents)
   * @param {number} libraryId
   * @returns {Promise} Array of analysis objects
   */
  getPaabAnalysesForLibrary: function (libraryId) {
    return httpClient.get(
      "/document_libraries/" + libraryId + "/paab_analyses"
    );
  },

  /**
   * Get a single PAAB analysis with all its findings
   * @param {number} analysisId
   * @returns {Promise} Analysis object with findings array
   */
  getPaabAnalysis: function (analysisId) {
    return httpClient.get("/paab_analyses/" + analysisId);
  },

  /**
   * Create a new PAAB analysis for a document
   * @param {number} documentId
   * @returns {Promise} Newly created analysis object
   */
  createPaabAnalysis: function (documentId) {
    return httpClient.post("/documents/" + documentId + "/paab_analyses");
  },

  /**
   * Get a single PAAB finding with full details
   * @param {number} findingId
   * @returns {Promise} Finding object
   */
  getPaabFinding: function (findingId) {
    return httpClient.get("/paab_findings/" + findingId);
  },

  // ===================
  // FDA Analysis (USA)
  // ===================

  /**
   * Get all FDA analyses for a document
   * @param {number} documentId
   * @returns {Promise} Array of analysis objects
   */
  getFdaAnalysesForDocument: function (documentId) {
    return httpClient.get("/documents/" + documentId + "/fda_analyses");
  },

  /**
   * Get all FDA analyses for a library (across all documents)
   * @param {number} libraryId
   * @returns {Promise} Array of analysis objects
   */
  getFdaAnalysesForLibrary: function (libraryId) {
    return httpClient.get("/document_libraries/" + libraryId + "/fda_analyses");
  },

  /**
   * Get a single FDA analysis with all its findings
   * @param {number} analysisId
   * @returns {Promise} Analysis object with findings array
   */
  getFdaAnalysis: function (analysisId) {
    return httpClient.get("/fda_analyses/" + analysisId);
  },

  /**
   * Create a new FDA analysis for a document
   * @param {number} documentId
   * @returns {Promise} Newly created analysis object
   */
  createFdaAnalysis: function (documentId) {
    return httpClient.post("/documents/" + documentId + "/fda_analyses");
  },

  /**
   * Get a single FDA finding with full details
   * @param {number} findingId
   * @returns {Promise} Finding object
   */
  getFdaFinding: function (findingId) {
    return httpClient.get("/fda_findings/" + findingId);
  },

  // ===================
  // Legacy aliases (for backward compatibility)
  // ===================

  getAnalysesForDocument: function (documentId) {
    return this.getPaabAnalysesForDocument(documentId);
  },

  getAnalysesForLibrary: function (libraryId) {
    return this.getPaabAnalysesForLibrary(libraryId);
  },

  getAnalysis: function (analysisId) {
    return this.getPaabAnalysis(analysisId);
  },

  createAnalysis: function (documentId) {
    return this.createPaabAnalysis(documentId);
  },

  getFinding: function (findingId) {
    return this.getPaabFinding(findingId);
  },
};

export default PaigeReview;
